import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingEvaluation = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [evaluation, setEvaluation] = useState('');
    const token = sessionStorage.getItem('token');

    // Set the initial evaluation value
    useEffect(() => {
        if (training.evaluation) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.evaluation;  // Convert HTML to plain text if applicable
            setEvaluation(tempDiv.innerText);  // Use plain text for editing
        } else {
            // Default placeholder if no evaluation content is provided
            setEvaluation(`
                Épreuve écrite :
                - Épreuve écrite 1 : 1 QCM de 40 questions portant sur l'ensemble du programme.
                - Épreuve écrite 2 : Élaboration d'une notice technique de sécurité lors d'un aménagement.

                Le rendu portera sur :
                - la présentation générale du projet,
                - la nature des travaux,
                - les incidences administratives et techniques vis-à-vis de la commission de sécurité.

                Épreuve Orale :
                Pour les épreuves écrites, une moyenne inférieure à 12 entraîne l'ajournement.
                
                Le jury d'examen est présidé soit par le directeur départemental des services d'incendie et de secours ou leurs représentants respectifs.
            `);
        }
    }, [training.evaluation]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleEvaluationChange = (event) => {
        setEvaluation(event.target.value); // Update evaluation content when user types
    };

    const handleSaveClick = async () => {
        // Save the modified evaluation back to the training object
        training.evaluation = evaluation;

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false); // Exit edit mode after saving
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    {/* Edit mode: textarea for changing the evaluation content */}
                    <label>Évaluation de la formation :</label>
                    <textarea
                        value={evaluation}
                        onChange={handleEvaluationChange}
                        rows={10}
                        style={{ width: '100%' }}
                    />
                </div>
            ) : (
                // Display mode: Show the evaluation content or placeholder text
                <div style={{ whiteSpace: 'pre-wrap' }}>{evaluation}</div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingEvaluation;